import React from 'react';
import {
  Container, Typography, Grid, Card, CardContent, Box, List,
  ListItem, ListItemIcon, ListItemText, Paper, Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StorageIcon from '@mui/icons-material/Storage';
import DnsIcon from '@mui/icons-material/Dns';
import CloudIcon from '@mui/icons-material/Cloud';
import TerminalIcon from '@mui/icons-material/Terminal';

const services = [
  'Windows Server installation and administration',
  'Linux server deployment and management',
  'VMware vSphere / ESXi virtualization',
  'Proxmox VE hypervisor setup and management',
  'Virtual machine deployment and migration',
  'Active Directory and Group Policy administration',
  'DHCP, DNS, and print server administration',
  'Antivirus and messaging server management',
  'Server performance monitoring and optimization',
  'Backup configuration and disaster recovery',
  'Multi-site LAN/WAN infrastructure support',
  'Server rack installation and cabling',
];

const benefits = [
  {
    icon: StorageIcon,
    title: '500+ Servers Deployed',
    description: 'Automated OS deployments for 500+ Windows/Linux servers and workstations',
  },
  {
    icon: CloudIcon,
    title: 'Virtualization Expert',
    description: 'VMware vSphere/ESXi and Proxmox VE — virtual machine migrations and high availability',
  },
  {
    icon: DnsIcon,
    title: 'Active Directory',
    description: 'Full AD administration including Group Policy, users, security groups, and policies',
  },
  {
    icon: TerminalIcon,
    title: 'PowerShell Automation',
    description: 'Custom PowerShell scripts to automate provisioning, reporting, and maintenance',
  },
];

function ServerAdministration() {
  return (
    <Box sx={{ py: 6, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h2" component="h1" className="gradient-text" sx={{ mb: 3 }}>
            Server & Infrastructure Administration
          </Typography>
          <Typography variant="h5" sx={{ color: 'text.secondary', mb: 4 }}>
            Windows/Linux servers, VMware, Proxmox, and Active Directory — full infrastructure management
          </Typography>
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            size="large"
            sx={{
              py: 2, px: 4, fontSize: '1.2rem',
              background: 'linear-gradient(45deg, #2563eb 30%, #3b82f6 90%)',
              '&:hover': { background: 'linear-gradient(45deg, #3b82f6 30%, #2563eb 90%)' }
            }}
          >
            Schedule Consultation
          </Button>
        </Box>

        <Grid container spacing={4} sx={{ mb: 8 }}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card className="glass-effect card-hover" sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Box sx={{ mb: 2, color: 'primary.main' }}>
                    {React.createElement(benefit.icon, { sx: { fontSize: 40 } })}
                  </Box>
                  <Typography variant="h6" gutterBottom>{benefit.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{benefit.description}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Paper elevation={3} sx={{ p: 4, background: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>Server Services Offered</Typography>
          <Grid container spacing={2}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemIcon><CheckCircleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary={service} />
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default ServerAdministration;
